export default __webpack_public_path__ + "static/media/78b40d84c041268f.7fe79297981be06ffcf80c4c710285d6.svg";